import React from 'react';

import './menu-label.scss';

export type MenuLabelProps = {
  label: string;
};

/**
 * Represents a menu label for a nav
 * @param param0 the props
 */
const MenuLabel: React.FC<MenuLabelProps> = ({ label }: MenuLabelProps) => {
  return <span className="menu-label">{label}</span>;
};

export default MenuLabel;
